import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Helper } from '../helpers/helper';

@Injectable()
export class PadronService  {
public url = 'http://69.64.59.186:2014';
  constructor(private _http: HttpClient, private helper: Helper ) {  }

  // Cargar datos clientes por su cedula
  getCedula(cedula: string) {
    const  headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      const data = {
          cedula
      };
    return this._http.post(`${this.url}/search/client`, data ,
    {headers});
  }

  registrarCedula(data: any) {
    const  headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
    return this._http.post(`${this.url}/add/cedula`, data,
    {headers});
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/padron.service.ts